// extracted by mini-css-extract-plugin
module.exports = {"container":"AdditionalInfo_container__dGt2O","title":"AdditionalInfo_title__hk5FV","text":"AdditionalInfo_text__53L_h"};